import request from '@/utils/request'
//searchZoneList
export function searchZoneList(param) {
    let data = param
    return request({
      url: `/v80/searchZoneList`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
}
//getDivision
export function getDivision(param) {
  let data = param
  return request({
    url: `/v80/getDivision`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}  
//getArea
export function getArea(param) {
  let data = param
  return request({
    url: `/v80/getArea`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}  

//getCheckPoint
export function getCheckPoint(param) {
  let data = param
  return request({
    url: `/v80/getCheckPoint`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
} 

// THÊM VÀO FILE API JS CỦA BẠN
export function saveZone(param) {
  let data = param
  return request({
    url: `/v80/saveZone`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}
// API Tải file riêng biệt lên FTP
export function uploadZoneFileFtp(formData) {
  return request({
    url: '/v80/uploadZoneFileFtp',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

// API Xóa file riêng biệt trên FTP
export function deleteZoneFile(params) {
  return request({
    url: '/v80/deleteZoneFile',
    method: 'post',
    params: params // Truyền qua RequestParam hoặc URLSearchParams
  })
}

// Delete Zone
export function deleteZone(param) {
  let data = param
  // console.log('param', param)
  return request({
    url: `/v80/deleteZone`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}

// New/modify Zone Final
export function createZone(param) {
  let data = param
  console.log('param', param)
  return request({
    url: `/v80/createZone`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}
//save01
export function save01(param) {
  let data = param
  console.log('param', param)
  return request({
    url: `/v80/save01`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}

//delete1
export function delete1(param) {
  let data = param
  console.log('param', param)
  return request({
    url: `/v80/delete1`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}



 
